<template>
  <div :class="[$style.container, `columns`]">
    <div class="column is-2">
      <img
        src="@/assets/images/JBI_subscription_Header_image.png"
        :class="$style.leftImage"
      />
    </div>
    <div class="column">
      <p :class="$style.FirstLine">Create your own project with PACES</p>
      <p :class="$style.SecondLine">
        PACES is a premier software to aid research created by a team of
        experienced researchers in JBI. Easily collect, manage, and analyse data
        collection in just one platform.
      </p>
      <p :class="$style.thirdLine">Subscribe now!</p>
    </div>
    <div class="column is-3 has-text-centered">
      <b-button
        rounded
        @click="redirect"
        :class="[$style.redirectBtn, `is-primary is-large`]"
        type="is-primary"
      >
        Subscribe to PACES
      </b-button>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
@Component({})
export default class ProjectSubscription extends Vue {
  public redirect() {
    window.location.href =
      'https://www.wolterskluwer.com/en/know/jbi-resources?utm_source=email_marketing&utm_medi[…]m=email&utm_campaign=health_hlrp_pr_ovid_4-v821_jbi_202407';
  }
}
</script>
<style lang="scss" module>
.container {
  margin: 16px;
  background-color: #eff7ff;
  border-radius: 4px;
  height: 155px;
}
.FirstLine {
  padding-top: 24px;
  color: #00205b;
  font-weight: bold;
}
.SecondLine {
  padding-top: 10px;
  color: #444f51;
  font-size: 14px;
}
.thirdLine {
  color: #444f51;
  font-size: 14px;
  font-weight: bold;
}
.redirectBtn {
  margin-top: 38px;
}
.leftImage {
  padding: 30px;
}
</style>
